export default __webpack_public_path__ + "static/media/kitchen5-beforeB-2048w.8d2edf35.png";